type OpenOptions = {
	source: string;
	sourceType: 'GET' | 'POST';
	dataToSend: unknown;
};

export type MetroPopupInstance = {
	open(options: OpenOptions): void;
	onSuccess?(): void;
};

declare global {
	interface Window {
		__PLATFORM__metroPopup: {
			_privateResolver: null | ((value: PromiseLike<MetroPopupInstance>) => void);
			promiseInstance: null | Promise<MetroPopupInstance>;
		};
	}
}

export function initOldPopupAPI() {
	window.__PLATFORM__metroPopup = {
		_privateResolver: null,
		promiseInstance: null,
	};

	window.__PLATFORM__metroPopup.promiseInstance = new Promise((resolve) => {
		window.__PLATFORM__metroPopup._privateResolver = resolve;
	});
}
